document.addEventListener('DOMContentLoaded', function () {
  var bars = document.querySelectorAll('[data-reliv-sticky-atc]');

  bars.forEach(function (bar) {
    var targetId = bar.getAttribute('data-target-button');
    var targetButton = document.getElementById(targetId);
    if (!targetButton) return;

    var priceEl = bar.querySelector('[data-reliv-sticky-price]');
    var stickyButton = bar.querySelector('[data-reliv-sticky-button]');

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          bar.classList.toggle('is-visible', !entry.isIntersecting);
        });
      },
      { threshold: 0 }
    );
    observer.observe(targetButton);

    window.addEventListener('reliv:offer-selected', function (evt) {
      if (priceEl && evt.detail && evt.detail.price) {
        priceEl.textContent = evt.detail.price;
      }
    });

    if (stickyButton) {
      stickyButton.addEventListener('click', function () {
        targetButton.scrollIntoView({ behavior: 'smooth', block: 'center' });
        window.setTimeout(function () {
          targetButton.click();
        }, 350);
      });
    }
  });
});
